var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            "use strict";
            var ITaskTagOrigem;
            (function (ITaskTagOrigem) {
                ITaskTagOrigem["MANUAL"] = "MANUAL";
                ITaskTagOrigem["AUTOMATICA"] = "AUTOMATICA";
            })(ITaskTagOrigem = minhasTarefas.ITaskTagOrigem || (minhasTarefas.ITaskTagOrigem = {}));
            var TaskCommand = /** @class */ (function () {
                function TaskCommand(context, taskId) {
                    this.context = context;
                    this.taskId = taskId;
                }
                return TaskCommand;
            }());
            minhasTarefas.TaskCommand = TaskCommand;
            var SetPriorityTaskCommand = /** @class */ (function (_super) {
                __extends(SetPriorityTaskCommand, _super);
                function SetPriorityTaskCommand() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.priority = false;
                    return _this;
                }
                return SetPriorityTaskCommand;
            }(TaskCommand));
            minhasTarefas.SetPriorityTaskCommand = SetPriorityTaskCommand;
            var SetNotesTaskCommand = /** @class */ (function (_super) {
                __extends(SetNotesTaskCommand, _super);
                function SetNotesTaskCommand() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.notes = "";
                    return _this;
                }
                return SetNotesTaskCommand;
            }(TaskCommand));
            minhasTarefas.SetNotesTaskCommand = SetNotesTaskCommand;
            var SetTagsTaskCommand = /** @class */ (function (_super) {
                __extends(SetTagsTaskCommand, _super);
                function SetTagsTaskCommand() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.tags = [];
                    return _this;
                }
                return SetTagsTaskCommand;
            }(TaskCommand));
            minhasTarefas.SetTagsTaskCommand = SetTagsTaskCommand;
            var RemoveTagTaskCommand = /** @class */ (function (_super) {
                __extends(RemoveTagTaskCommand, _super);
                function RemoveTagTaskCommand() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return RemoveTagTaskCommand;
            }(TaskCommand));
            minhasTarefas.RemoveTagTaskCommand = RemoveTagTaskCommand;
            var ContextTasksCommand = /** @class */ (function () {
                function ContextTasksCommand() {
                }
                ContextTasksCommand.prototype.addTasks = function (tasks) {
                    var _this = this;
                    if (angular.isArray(tasks)) {
                        tasks.forEach(function (task) { return _this.addTask(task); });
                    }
                };
                ContextTasksCommand.prototype.addTask = function (task) {
                    if (this.contextTasks && this.contextTasks[task.context]) {
                        this.contextTasks[task.context].push(task.id);
                    }
                    else {
                        this.contextTasks = {};
                        this.contextTasks[task.context] = [task.id];
                    }
                };
                return ContextTasksCommand;
            }());
            minhasTarefas.ContextTasksCommand = ContextTasksCommand;
            var AssumeTasksCommand = /** @class */ (function (_super) {
                __extends(AssumeTasksCommand, _super);
                function AssumeTasksCommand() {
                    return _super.call(this) || this;
                }
                return AssumeTasksCommand;
            }(ContextTasksCommand));
            minhasTarefas.AssumeTasksCommand = AssumeTasksCommand;
            var AssigneeTasksCommand = /** @class */ (function (_super) {
                __extends(AssigneeTasksCommand, _super);
                function AssigneeTasksCommand() {
                    return _super.call(this) || this;
                }
                return AssigneeTasksCommand;
            }(ContextTasksCommand));
            minhasTarefas.AssigneeTasksCommand = AssigneeTasksCommand;
            var AssigneeTasksCommandValidator = /** @class */ (function () {
                function AssigneeTasksCommandValidator() {
                }
                AssigneeTasksCommandValidator.prototype.isValid = function (command) {
                    return !!command.contextTasks;
                };
                return AssigneeTasksCommandValidator;
            }());
            minhasTarefas.AssigneeTasksCommandValidator = AssigneeTasksCommandValidator;
            var AssigneeGroupTasksCommand = /** @class */ (function (_super) {
                __extends(AssigneeGroupTasksCommand, _super);
                function AssigneeGroupTasksCommand() {
                    return _super.call(this) || this;
                }
                return AssigneeGroupTasksCommand;
            }(ContextTasksCommand));
            minhasTarefas.AssigneeGroupTasksCommand = AssigneeGroupTasksCommand;
            var AssigneeTagTasksCommand = /** @class */ (function () {
                function AssigneeTagTasksCommand(tasks) {
                    this.tasks = tasks;
                    this.tags = [];
                }
                return AssigneeTagTasksCommand;
            }());
            minhasTarefas.AssigneeTagTasksCommand = AssigneeTagTasksCommand;
            var UnAssigneeTagTasksCommand = /** @class */ (function () {
                function UnAssigneeTagTasksCommand(tasks) {
                    this.tasks = tasks;
                    this.tags = [];
                }
                return UnAssigneeTagTasksCommand;
            }());
            minhasTarefas.UnAssigneeTagTasksCommand = UnAssigneeTagTasksCommand;
            var AssigneeGroupTasksCommandValidator = /** @class */ (function () {
                function AssigneeGroupTasksCommandValidator() {
                }
                AssigneeGroupTasksCommandValidator.prototype.isValid = function (command) {
                    return !!command.contextTasks;
                };
                return AssigneeGroupTasksCommandValidator;
            }());
            minhasTarefas.AssigneeGroupTasksCommandValidator = AssigneeGroupTasksCommandValidator;
            var CancelTasksCommand = /** @class */ (function (_super) {
                __extends(CancelTasksCommand, _super);
                function CancelTasksCommand() {
                    return _super.call(this) || this;
                }
                return CancelTasksCommand;
            }(ContextTasksCommand));
            minhasTarefas.CancelTasksCommand = CancelTasksCommand;
            var CancelTasksCommandValidator = /** @class */ (function () {
                function CancelTasksCommandValidator() {
                }
                CancelTasksCommandValidator.prototype.isValid = function (command) {
                    if (!!command.reason) {
                        if (command.reason.length === 1) {
                            command.reason = command.reason.trim();
                        }
                        return command.reason.length > 0 && command.reason.length <= 500 && !!command.contextTasks;
                    }
                    return false;
                };
                return CancelTasksCommandValidator;
            }());
            minhasTarefas.CancelTasksCommandValidator = CancelTasksCommandValidator;
            var SetNotesTaskCommandValidator = /** @class */ (function () {
                function SetNotesTaskCommandValidator() {
                }
                SetNotesTaskCommandValidator.prototype.isValid = function (command) {
                    if (!!command.notes) {
                        if (command.notes.length === 1) {
                            command.notes = command.notes.trim();
                        }
                        return command.notes.length > 0 && command.notes.length <= 500;
                    }
                    return false;
                };
                return SetNotesTaskCommandValidator;
            }());
            minhasTarefas.SetNotesTaskCommandValidator = SetNotesTaskCommandValidator;
            var SetTagsTaskCommandValidator = /** @class */ (function () {
                function SetTagsTaskCommandValidator() {
                }
                SetTagsTaskCommandValidator.prototype.isValid = function (command) {
                    if (!!command.tags) {
                        return command.tags.length > 0;
                    }
                    return false;
                };
                return SetTagsTaskCommandValidator;
            }());
            minhasTarefas.SetTagsTaskCommandValidator = SetTagsTaskCommandValidator;
            var RemoveTagTaskCommandValidator = /** @class */ (function () {
                function RemoveTagTaskCommandValidator() {
                }
                RemoveTagTaskCommandValidator.prototype.isValid = function (command) {
                    return !!command.tag;
                };
                return RemoveTagTaskCommandValidator;
            }());
            minhasTarefas.RemoveTagTaskCommandValidator = RemoveTagTaskCommandValidator;
            var CamposExportacaoTarefa = /** @class */ (function () {
                function CamposExportacaoTarefa(nome, descricao, isAtivo, tipo, funcaoDeFormatacao) {
                    if (nome === void 0) { nome = ''; }
                    if (funcaoDeFormatacao === void 0) { funcaoDeFormatacao = ''; }
                    this.nome = nome;
                    this.descricao = descricao;
                    this.isAtivo = isAtivo;
                    this.tipo = tipo;
                    this.funcaoDeFormatacao = funcaoDeFormatacao;
                }
                return CamposExportacaoTarefa;
            }());
            minhasTarefas.CamposExportacaoTarefa = CamposExportacaoTarefa;
            var MinhasTarefasService = /** @class */ (function () {
                /** @ngInject **/
                function MinhasTarefasService($http, $q, $document, $state, $mdDialog, commandService, messagesService, authService, properties, identidadesService) {
                    this.$http = $http;
                    this.$q = $q;
                    this.$document = $document;
                    this.$state = $state;
                    this.$mdDialog = $mdDialog;
                    this.commandService = commandService;
                    this.messagesService = messagesService;
                    this.authService = authService;
                    this.properties = properties;
                    this.identidadesService = identidadesService;
                    this.apiTarefas = properties.apiUrl + "/integracoes-modulos/api/tasks";
                    this.apiTarefasHistorico = properties.apiUrl + "/integracoes-tarefas/api/tasks";
                    this.apiUsuarios = properties.apiUrl + "/integracoes-identidades/api/acessos";
                    this.commandService.addValidator("atribuir-tarefas", new AssigneeTasksCommandValidator());
                    this.commandService.addValidator("atribuir-tarefas-grupo", new AssigneeGroupTasksCommandValidator());
                    this.commandService.addValidator("cancelar-tarefas", new CancelTasksCommandValidator());
                    this.commandService.addValidator("anotar-tarefa", new SetNotesTaskCommandValidator());
                    this.commandService.addValidator("rotular-tarefa", new SetTagsTaskCommandValidator());
                    this.commandService.addValidator("remover-rotulo-tarefa", new RemoveTagTaskCommandValidator());
                }
                MinhasTarefasService.prototype.get = function () {
                    return this.$http.get(this.apiTarefas);
                };
                MinhasTarefasService.prototype.getNomesUsuarios = function (logins) {
                    return this.identidadesService.getNomeApresentacao(logins);
                };
                MinhasTarefasService.prototype.loadTaskDraft = function (task) {
                    return this.$http.get(this.apiTarefas + "/draft/" + task.context + "/" + task.id);
                };
                MinhasTarefasService.prototype.deleteTaskDraft = function (task) {
                    return this.$http.delete(this.apiTarefas + "/draft/" + task.context + "/" + task.id);
                };
                MinhasTarefasService.prototype.setPriority = function (cmd) {
                    return this.$http.post(this.apiTarefas + "/priority", cmd);
                };
                MinhasTarefasService.prototype.setNotes = function (cmd) {
                    return this.$http.post(this.apiTarefas + "/notes", cmd);
                };
                MinhasTarefasService.prototype.setTags = function (cmd) {
                    return this.$http.post(this.properties.apiUrl + "/" + cmd.context + "/api/tasks/" + cmd.taskId + "/tags", cmd);
                };
                MinhasTarefasService.prototype.setTagsTasks = function (cmd) {
                    var _this = this;
                    var promisses = [];
                    cmd.tasks.forEach(function (task) {
                        var command = new SetTagsTaskCommand(task.context, task.id);
                        command.tags = cmd.tags;
                        promisses.push(_this.setTags(command));
                    });
                    return this.$q.all(promisses);
                };
                MinhasTarefasService.prototype.unsetTagsTasks = function (cmd) {
                    var _this = this;
                    var promisses = [];
                    if (!!cmd.tasks && !!cmd.tags) {
                        cmd.tasks.forEach(function (task) {
                            var promise = _this.$q.resolve({});
                            cmd.tags
                                .filter(function (tag) { return task.tags.some(function (t) { return t.id === tag; }); })
                                .forEach(function (tag) {
                                var command = new RemoveTagTaskCommand(task.context, task.id);
                                command.tag = tag;
                                promise = promise.then(function () { return _this.removeTag(command); });
                            });
                            promisses.push(promise);
                        });
                    }
                    return this.$q.all(promisses);
                };
                MinhasTarefasService.prototype.removeTag = function (cmd) {
                    return this.$http.delete(this.properties.apiUrl + "/" + cmd.context + "/api/tasks/" + cmd.taskId + "/tags/" + cmd.tag);
                };
                MinhasTarefasService.prototype.assignTasks = function (cmd) {
                    return this.$http.post(this.apiTarefas + "/assignment", cmd);
                };
                MinhasTarefasService.prototype.assignGroupTasks = function (cmd) {
                    return this.$http.post(this.apiTarefas + "/group/assignment", cmd);
                };
                MinhasTarefasService.prototype.assumeTasks = function (cmd) {
                    return this.$http.post(this.apiTarefas + "/user", cmd);
                };
                MinhasTarefasService.prototype.cancelTasks = function (cmd) {
                    cmd.reason = cmd.reason.trim();
                    return this.$http.post(this.apiTarefas + "/canceled", cmd);
                };
                MinhasTarefasService.prototype.listCanceledTasks = function (from, to, filterDefault) {
                    var config = {
                        params: {
                            from: from,
                            to: to,
                            filterDefault: filterDefault,
                        }
                    };
                    return this.$http
                        .get(this.apiTarefasHistorico + "/canceled", config)
                        .then(function (response) { return response.data; }, function () { return []; });
                };
                MinhasTarefasService.prototype.listCompletedTasks = function (from, to, filterDefault) {
                    var config = {
                        params: {
                            from: from,
                            to: to,
                            filterDefault: filterDefault
                        }
                    };
                    return this.$http
                        .get(this.apiTarefasHistorico + "/completed", config)
                        .then(function (response) { return response.data; }, function () { return []; });
                };
                MinhasTarefasService.prototype.listUsersByResources = function (resources, filterBySetorUsuario) {
                    var _this = this;
                    var query = { permissoes: resources, lotacao: null };
                    var login = this.authService.getUserLogin();
                    if (filterBySetorUsuario) {
                        return this.authService.getUser()
                            .then(function (user) {
                            query.lotacao = user.lotacao;
                            return _this.$http.post(_this.apiUsuarios + "/usuarios/recursos", query)
                                .then(function (response) {
                                return response.data.filter(function (user) { return user.login !== login; });
                            });
                        });
                    }
                    return this.$http.post(this.apiUsuarios + "/usuarios/recursos", query)
                        .then(function (response) {
                        return response.data.filter(function (user) { return user.login !== login; });
                    });
                };
                MinhasTarefasService.prototype.listGroups = function () {
                    var _this = this;
                    return this.$http.get(this.apiUsuarios + "/usuario/grupos?tipo=SETOR", { cache: true })
                        .then(function (response) {
                        var groups = [];
                        response.data.forEach(function (g) { return _this.addSubgroups(g, groups); });
                        return _.orderBy(groups, "nomeArvore");
                    });
                };
                MinhasTarefasService.prototype.notifyOpenTask = function (notification) {
                    var _this = this;
                    var task = notification.content;
                    this.$q.all([this.commandService.findByIdAndContext(task.command, task.context), this.authService.getUser()])
                        .then(function (values) {
                        if (values[0].notifyToOpenTask && values[1].login === notification.sender) {
                            _this.messagesService.task("Tarefa criada \"" + task.title + "\"", "Abrir")
                                .then(function (response) {
                                if (response === "ok") {
                                    _this.openTask(task);
                                }
                            });
                        }
                    });
                };
                MinhasTarefasService.prototype.openTask = function (task) {
                    var _this = this;
                    this.authService.getUser().then(function (user) {
                        if (task.assignee === null) {
                            var cmd = new AssumeTasksCommand();
                            cmd.addTask(task);
                            return _this.assumeTasks(cmd)
                                .then(function () {
                                _this.loadTask(task);
                                task.assignee = user.login;
                                task.selfAssigned = true;
                                return task;
                            });
                        }
                        else {
                            if (task.assignee !== user.login) {
                                _this.getNomesUsuarios([task.assignee]).then(function (resultado) {
                                    var nomeUsuario = task.assignee;
                                    for (var _i = 0, _a = Object.entries(resultado); _i < _a.length; _i++) {
                                        var _b = _a[_i], key = _b[0], value = _b[1];
                                        nomeUsuario = value;
                                    }
                                    _this.assumeDialog(task, nomeUsuario).then(function (response) {
                                        var cmd = new AssumeTasksCommand();
                                        cmd.addTask(task);
                                        _this.assumeTasks(cmd)
                                            .then(function () {
                                            task.assignee = user.login;
                                            task.selfAssigned = true;
                                            _this.loadTask(task);
                                        });
                                    });
                                });
                            }
                            else {
                                _this.loadTask(task);
                            }
                        }
                    });
                };
                MinhasTarefasService.prototype.assumeTask = function (task) {
                    var _this = this;
                    return this.authService.getUser().then(function (user) {
                        if (task.assignee === null) {
                            var cmd = new AssumeTasksCommand();
                            cmd.addTask(task);
                            return _this.assumeTasks(cmd)
                                .then(function () {
                                task.assignee = user.login;
                                task.selfAssigned = true;
                                return task;
                            });
                        }
                        else if (task.assignee !== user.login) {
                            _this.getNomesUsuarios([task.assignee]).then(function (resultado) {
                                var nomeUsuario = task.assignee;
                                for (var _i = 0, _a = Object.entries(resultado); _i < _a.length; _i++) {
                                    var _b = _a[_i], key = _b[0], value = _b[1];
                                    nomeUsuario = value;
                                }
                                return _this.assumeDialog(task, nomeUsuario).then(function (response) {
                                    var cmd = new AssumeTasksCommand();
                                    cmd.addTask(task);
                                    return _this.assumeTasks(cmd).then(function () {
                                        task.assignee = user.login;
                                        task.selfAssigned = true;
                                        return task;
                                    });
                                });
                            });
                        }
                        else {
                            return task;
                        }
                    });
                };
                MinhasTarefasService.prototype.isTaskAssignedToLoggedUser = function (task) {
                    return this.authService.getUser().then(function (user) {
                        return task.assignee === user.login;
                    });
                };
                MinhasTarefasService.prototype.viewTask = function (task, additionalParams) {
                    this.loadTask(task, additionalParams, true);
                };
                MinhasTarefasService.prototype.deleteTaskDraftByNotification = function (notification) {
                    var _this = this;
                    this.authService.getUser().then(function (user) {
                        if (notification.sender === user.login) {
                            var task = notification.content;
                            _this.deleteTaskDraft(task);
                        }
                    });
                };
                MinhasTarefasService.prototype.assumeDialog = function (task, nomeUsuario) {
                    var _this = this;
                    return this.authService.getUser().then(function (user) {
                        var title;
                        var content;
                        if (task.assignee && task.assignee !== user.login) {
                            title = "Tarefa atribu\u00EDda a outro usu\u00E1rio!";
                            content = "A tarefa '" + task.title + "' foi atribu\u00EDda a '" + nomeUsuario + "'. ";
                        }
                        else {
                            title = "Assumir tarefa?";
                            content = "A tarefa n\u00E3o possui respons\u00E1vel. ";
                        }
                        content += "Deseja assumi-la?";
                        return _this.$mdDialog.show(_this.$mdDialog.confirm()
                            .title(title)
                            .textContent(content)
                            .clickOutsideToClose(false)
                            .parent(_this.$document.find("body"))
                            .ok("Assumir")
                            .cancel("Cancelar"));
                    });
                };
                MinhasTarefasService.prototype.loadTask = function (task, additionalParams, isView) {
                    var _this = this;
                    if (isView === void 0) { isView = false; }
                    this.authService.getUser().then(function (user) {
                        task.isView = isView;
                        if (task.assignee && task.assignee === user.login) {
                            task.selfAssigned = true;
                        }
                        _this.commandService.findByIdAndContext(task.command, task.context)
                            .then(function (command) { return _this.openTaskWithDraft(task, command, additionalParams); })
                            .catch(function (reason) {
                            _this.messagesService.error("Voc\u00EA n\u00E3o tem permiss\u00E3o para abrir a tarefa: " + task.title + ".");
                            throw new Error(reason);
                        });
                    });
                };
                MinhasTarefasService.prototype.openTaskWithDraft = function (task, command, additionalParams) {
                    var _this = this;
                    var contextTask = angular.copy(task);
                    if (!command.route || !command.route.types || command.route.types.find(function (x) { return x == 'ui1'; })) {
                        if (task.draft && task.draft.modifiedBy && task.draft.modifiedDate) {
                            var draft_1;
                            this.loadTaskDraft(task)
                                .then(function (taskDraft) {
                                if (taskDraft) {
                                    draft_1 = taskDraft.commandJSON;
                                }
                            }).finally(function () {
                                _this.$state.go(command.route.stateName, Object.assign({ task: contextTask, draft: draft_1 }, additionalParams));
                            });
                        }
                        else {
                            this.$state.go(command.route.stateName, Object.assign({ task: contextTask }, additionalParams));
                        }
                    }
                    else if (command.route.types.find(function (x) { return 'ui2'; })) {
                        this.$state.go('app.upgraded', Object.assign({ url: "tarefas/" + task.context + "/" + task.id }));
                    }
                };
                MinhasTarefasService.prototype.addSubgroups = function (group, groups) {
                    var _this = this;
                    groups.push(group);
                    if (!!group.subgrupos && group.subgrupos.length > 0) {
                        group.subgrupos
                            .filter(function (g) { return groups.findIndex(function (group) { return group.id === g.id; }) == -1; })
                            .forEach(function (g) { return _this.addSubgroups(g, groups); });
                        group.subgrupos = [];
                    }
                };
                return MinhasTarefasService;
            }());
            minhasTarefas.MinhasTarefasService = MinhasTarefasService;
            var SERVICE_NAME = "app.tarefas.minhas-tarefas.MinhasTarefasService";
            var config = /** @ngInject */ function (errorHandlerProvider, httpPromiseTransformationProvider, $provide) {
                httpPromiseTransformationProvider.decorate($provide, SERVICE_NAME);
                errorHandlerProvider.decorate($provide, SERVICE_NAME);
            };
            angular
                .module("app.tarefas.minhas-tarefas")
                .service(SERVICE_NAME, MinhasTarefasService)
                .config(config);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));
